import { useSelector } from "react-redux";
import CustomLink from "./ui/CustomLink";
import { loginSelector } from "@/store/features/loginSlice";

const Footer = () => {
  const { currentUser } = useSelector(loginSelector);

  if (currentUser === undefined) return null;
  return (
    <footer className="p-2 px-100 max-maxContainer:px-0 bg-footerBg md:fixed bottom-0 w-full">
      <div className="flex flex-col md:flex-row px-5 xl:px-0 justify-center md:justify-between  items-center md:items-start max-w-mainContainer mx-auto ">
        <div className="text-text-label  text-[.8125rem]">Copyright © {new Date().getFullYear()} Lystproof. All rights reserved</div>
        <div className="text-text-label  text-[.8125rem]">
          <CustomLink className="!text-text-label " isExternal link={{ value: "https://www.lystproof.com/terms-conditions", text: "Terms & Conditions" }} />
          | <CustomLink className="!text-text-label " isExternal link={{ value: "https://www.lystproof.com/privacy", text: "Privacy Policy" }} />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
